import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  FilledInput,
  Input,
  InputAdornment,
} from "@mui/material";

const TablaNotas = ({ materia, setMateria }) => {
  // Estados para manejar los valores de las celdas editables
  useState("");
  let calificaciones = materia.calificaciones || {};
  // Función para manejar cambios en las celdas editables

  const [ponderados, setPonderados] = useState({
    asistencia: 0,
    practicas: 0,
    auxiliaturas: 0,
    parciales: 3,
    parcial1: 0,
    parcial2: 0,
    parcial3: 0,
    final: 0.4,
  });

  const [notaPon, setNotaPon] = useState({
    asistencia: 0,
    practicas: 0,
    auxiliaturas: 0,
    parciales: 0,
    parcial1: 0,
    parcial2: 0,
    parcial3: 0,
    final: 0,
  });

  useEffect(() => {
    let pon = ponderados;
    pon.asistencia = materia.auxiliaturas ? 0.06 : 0.06;
    pon.practicas = materia.auxiliaturas ? 0.09 : 0.18;
    pon.auxiliaturas = materia.auxiliaturas ? 0.09 : 0;
    pon.parciales = materia.modalidad === "Semestral" ? 2 : 3;
    pon.parcial1 = materia.modalidad === "Semestral" ? 0.18 : 0.12;
    pon.parcial2 = materia.modalidad === "Semestral" ? 0.18 : 0.12;
    pon.parcial3 = materia.modalidad === "Semestral" ? 0 : 0.12;
    setPonderados(pon);
  }, [materia]);

  useEffect(() => {
    const calculoNota = () => {
      let nota = notaPon;
      nota.asistencia = (
        (calificaciones.asistencia || 0) * ponderados.asistencia
      ).toFixed(2);
      nota.practicas = (
        (calificaciones.practicas ?? 0) * ponderados.practicas
      ).toFixed(2);
      nota.auxiliaturas = (
        (calificaciones.auxiliaturas ?? 0) * ponderados.auxiliaturas
      ).toFixed(2);
      nota.parcial1 = (
        (calificaciones.parcial1 ?? 0) * ponderados.parcial1
      ).toFixed(2);
      nota.parcial2 = (
        (calificaciones.parcial2 ?? 0) * ponderados.parcial2
      ).toFixed(2);
      nota.parcial3 = (
        (calificaciones.parcial3 ?? 0) * ponderados.parcial3
      ).toFixed(2);
      nota.parciales = (
        ((parseInt(calificaciones.parcial1 || 0) +
          parseInt(calificaciones.parcial2 || 0) +
          parseInt(calificaciones.parcial3 || 0)) /
          ponderados.parciales) *
        0.36
      ).toFixed(2);
      nota.final = ((calificaciones.final ?? 0) * 0.4).toFixed(2);
      // console.log(nota);
      let final =
        parseFloat(nota.asistencia) +
        parseFloat(nota.practicas) +
        parseFloat(nota.auxiliaturas) +
        parseFloat(nota.parciales) +
        parseFloat(nota.final);
      // console.log(final, nota.final);
      setMateria({ totalPonderados: final });
      // setNotaPon(nota);
    };
    calculoNota();
  }, [calificaciones]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    // console.log(materia);

    if (value === "") {
      setMateria({
        calificaciones: { ...calificaciones, [name]: "" },
      });
    } else if (value >= 0 && value <= 100) {
      setMateria({
        calificaciones: { ...calificaciones, [name]: value },
      });
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>Tipo</TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              Nota
            </TableCell>
            <TableCell align="right" style={{ fontWeight: "bold" }}>
              Ponderación
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Asistencia */}
          <TableRow>
            <TableCell component="th" scope="row">
              Asistencia {ponderados.asistencia * 100} Pond.
            </TableCell>
            <TableCell align="right">
              <Input
                name="asistencia"
                id="asistencia"
                aria-describedby="standard-weight-helper-text"
                type="number"
                inputProps={{ min: 0, max: 100 }}
                value={calificaciones.asistencia ?? 0}
                onChange={handleInputChange}
                sx={{
                  textAlign: "center",
                  backgroundColor: "#f9f9f9",
                  "& input": {
                    textAlign: "center",
                  },
                }}
              />
            </TableCell>
            <TableCell align="right">
              {(
                (calificaciones.asistencia ?? 0) *
                ponderados.asistencia
              ).toFixed(2)}
            </TableCell>
          </TableRow>

          {/* Practicas */}
          <TableRow>
            <TableCell component="th" scope="row">
              Prácticas {ponderados.practicas * 100} Pond.
            </TableCell>

            <TableCell align="right">
              <Input
                id="practicas"
                name="practicas"
                aria-describedby="standard-weight-helper-text"
                type="number"
                inputProps={{ min: 0, max: 100 }}
                value={calificaciones.practicas ?? 0}
                onChange={handleInputChange}
                sx={{
                  textAlign: "center",
                  backgroundColor: "#f9f9f9",
                  "& input": {
                    textAlign: "center",
                  },
                }}
              />
            </TableCell>
            <TableCell align="right">
              {(
                (calificaciones.practicas ?? 0) * ponderados.practicas
              ).toFixed(2)}
            </TableCell>
          </TableRow>

          {/* Auxiliarias */}
          {materia.auxiliaturas && (
            <TableRow>
              <TableCell component="th" scope="row">
                Auxiliares {ponderados.auxiliaturas * 100} Pond.
              </TableCell>
              <TableCell align="right">
                <Input
                  id="auxiliaturas"
                  name="auxiliaturas"
                  aria-describedby="standard-weight-helper-text"
                  type="number"
                  inputProps={{ min: 0, max: 100 }}
                  value={calificaciones.auxiliaturas ?? 0}
                  sx={{
                    textAlign: "center",
                    backgroundColor: "#f9f9f9",
                    "& input": {
                      textAlign: "center",
                    },
                  }}
                  onChange={handleInputChange}
                />
              </TableCell>
              <TableCell align="right">
                {(
                  (calificaciones.auxiliaturas ?? 0) *
                  ponderados.auxiliaturas
                ).toFixed(2)}
              </TableCell>
            </TableRow>
          )}
          {/* Parciales */}
          <TableRow>
            <TableCell
              component="th"
              scope="row"
              colSpan={2}
              style={{ fontWeight: "bold" }}
            >
              Parciales 36 Pond.
            </TableCell>

            <TableCell align="right">
              {(
                ((parseInt(calificaciones.parcial1 || 0) +
                  parseInt(calificaciones.parcial2 || 0) +
                  parseInt(calificaciones.parcial3 || 0)) /
                  ponderados.parciales) *
                0.36
              ).toFixed(2)}
            </TableCell>
          </TableRow>

          {/* Primer Parcial 12 */}
          <TableRow>
            <TableCell component="th" scope="row">
              1er parcial {ponderados.parcial1 * 100} Pond.
            </TableCell>
            <TableCell align="right">
              <Input
                id="parcial1"
                name="parcial1"
                aria-describedby="standard-weight-helper-text"
                type="number"
                inputProps={{ min: 0, max: 100 }}
                value={calificaciones.parcial1 ?? 0}
                sx={{
                  textAlign: "center",
                  backgroundColor: "#f9f9f9",
                  "& input": {
                    textAlign: "center",
                  },
                }}
                onChange={handleInputChange}
              />
            </TableCell>
            <TableCell align="right">
              {(
                (calificaciones.parcial1 ?? 0) * ponderados.parcial1
              ).toFixed(2)}
            </TableCell>
          </TableRow>

          {/* Primer Parcial 13 */}
          <TableRow>
            <TableCell component="th" scope="row">
              2do parcial {ponderados.parcial2 * 100} Pond.
            </TableCell>
            <TableCell align="right">
              <Input
                id="parcial2"
                name="parcial2"
                aria-describedby="standard-weight-helper-text"
                type="number"
                inputProps={{ min: 0, max: 100 }}
                value={calificaciones.parcial2 ?? 0}
                sx={{
                  textAlign: "center",
                  backgroundColor: "#f9f9f9",
                  "& input": {
                    textAlign: "center",
                  },
                }}
                onChange={handleInputChange}
              />
            </TableCell>
            <TableCell align="right">
              {(
                (calificaciones.parcial2 ?? 0) * ponderados.parcial2
              ).toFixed(2)}
            </TableCell>
          </TableRow>

          {/* Primer Parcial 3 */}
          {materia.modalidad === "Anual" && (
            <TableRow>
              <TableCell component="th" scope="row">
                3er parcial {ponderados.parcial3 * 100} Pond.
              </TableCell>
              <TableCell align="right">
                <Input
                  id="parcial3"
                  name="parcial3"
                  aria-describedby="standard-weight-helper-text"
                  type="number"
                  inputProps={{ min: 0, max: 100 }}
                  value={calificaciones.parcial3 ?? 0}
                  sx={{
                    textAlign: "center",
                    backgroundColor: "#f9f9f9",
                    "& input": {
                      textAlign: "center",
                    },
                  }}
                  onChange={handleInputChange}
                />
              </TableCell>
              <TableCell align="right">
                {(
                  (calificaciones.parcial3 ?? 0) * ponderados.parcial3
                ).toFixed(2)}
              </TableCell>
            </TableRow>
          )}
          {/* Examenes Final */}
          <TableRow>
            <TableCell
              component="th"
              scope="row"
              sx={{
                fontWeight: "600",
                color: "#4b4b4bff",
              }}
            >
              Examen final 40 Pond.
            </TableCell>
            <TableCell align="right">
              <Input
                id="final"
                name="final"
                aria-describedby="standard-weight-helper-text"
                type="number"
                inputProps={{ min: 0, max: 100 }}
                value={calificaciones.final ?? 0}
                sx={{
                  textAlign: "center",
                  backgroundColor: "#f9f9f9",
                  "& input": {
                    textAlign: "center",
                  },
                }}
                onChange={handleInputChange}
              />
            </TableCell>
            <TableCell align="right">
              {((calificaciones.final ?? 0) * 0.4).toFixed(2)}
            </TableCell>
          </TableRow>

          {/* Calificacion Anual */}
          <TableRow>
            <TableCell
              component="th"
              scope="row"
              colSpan={2}
              style={{ fontWeight: "bold", fontSize: "1.1rem" }}
            >
              Calificación Final
            </TableCell>
            <TableCell
              align="right"
              style={{ fontWeight: "bold", fontSize: "1.1rem" }}
            >
              {materia.totalPonderados.toFixed(2)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TablaNotas;
